import { render } from "./RemoveDialog.vue?vue&type=template&id=3ada6de4&scoped=true"
import script from "./RemoveDialog.vue?vue&type=script&lang=js"
export * from "./RemoveDialog.vue?vue&type=script&lang=js"

import "./RemoveDialog.vue?vue&type=style&index=0&id=3ada6de4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ada6de4"]])

export default __exports__